/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ADDVIDEOTRIM, ADDVIDEOTRIM_RECEIVED , CLEAR_VIDEOTRIM} = constants.AddVideoTrimConstants;

export default {
  REQUEST_ADDVIDEOTRIM,
  ADDVIDEOTRIM_RECEIVED,
  CLEAR_VIDEOTRIM,

  requestAddVideoTrim: payload => ({
    type: REQUEST_ADDVIDEOTRIM,
    payload
  }),
  AddVideoTrimReceived: () => ({
    type: ADDVIDEOTRIM_RECEIVED
  })
};
